<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div
        class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        "
      >
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >หน้าแรก</router-link
              >
            </li>
            <li class="breadcrumb-item router-link active">แจ้งย้ายสาขา (ตัวแทนดำเนินการ)</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div
        class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        "
        style="background-color: #f2f2f2"
      >
        <div class="icon-back">
          <router-link to="/AgenteService">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div
          class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8"
        >
          แจ้งย้ายสาขา
        </div>
      </div>
      <!-- Mobile -->
      <div class="col col-content">
        <div class="d-none d-lg-flex align-items-center border-bottom">
          <div class="icon-back">
            <router-link to="/AgenteService">
              <img src="@/assets/images/arrow-blue.svg" class="w-100" />
            </router-link>
          </div>
          <div
            class="
              title
              blue-1
              fw-normal
              ps-md-3
              pe-lg-3
              font-family
              d-none d-md-block d-lg-block
            "
          >
            แจ้งย้ายสาขา (ตัวแทนดำเนินการ)
          </div>
        </div>
        <div class="pb-2 pb-lg-2">
          <div class="mt-2 mt-lg-2">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
              สาขาปัจจุบัน :
            </div>
            <div class="blue-1 fs-5 font-family">
              <label>{{ this.Branch }}</label>
            </div>
          </div>
        </div>
        <div class="pb-3 pb-lg-3">
          <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
            เปลี่ยนเป็น :
          </div>
          <div class="gray-3 fs-5 font-family">
            สาขาใหม่<span class="required">*</span>
          </div>
          <div class="font-family fs-5">
            <v-select
              v-model="ChangeBranch"
              :reduce="(option) => option.value"
              :options="this.ZTB_OFFICE"
              placeholder="กรุณาเลือกสาขา หรือ พิมพ์ชื่อสาขา"
            />
          </div>
        </div>
        <div class="pb-3 pb-lg-3">
          <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
            วัตถุประสงค์ของการขอย้าย<span class="required">*</span> :
          </div>
          <div class="fs-4 font-family">
            <input
              v-model="MemoChangBranch"
              type="text"
              class="field field__input a-field__input"
              style="border-bottom: 1px solid #d0d0d0"
              autocomplete="off"
            />
          </div>
        </div>
        <div class="col mt-2">
          <button class="btn-CB border border-0 rounded w-100 font-family" @click="EnterNext()">
            <label class="btn-next">ดำเนินการต่อ</label>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>
<script>
import Menu from "@/components/agenteservice/Menu.vue";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

export default {
  name: "ChangeBranchView",
  components: {
    Menu,
    LoadingBs5
  },
  data() {
    return {
      Loading: true,
      Branch: '',
      ChangeBranch: "",
      MemoChangBranch: "",
      ZTB_OFFICE: [],
    };
  },
  mounted() {
    if(this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }

    // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    http.get("AgencyERequest/GetName?",{ headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => { 
      if(res.status == 200) {
        this.$store.state.UserName = res.data.NAME + " " + res.data.SURNAME;
        this.Branch = res.data.DESCRIPTION;
        this.$store.state.UserOffice = res.data.OFFICE;
        this.Loading = false;
      }
      else { 
        this.Loading = false;
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
      }
    }).catch((error) => { 
      this.Loading = false;
      Swal.fire({
        icon: 'error',
        html: '<label class="fs-4 fw-normal font-family">'+ error.response.data.ErrorMessage +'</label>',
      }).then(() => { 
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
      });
    });

    http.get("AgencyERequest/GetOffice", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => { 
      if(res.status == 200) {
        res.data.forEach((item, index) => {
          this.ZTB_OFFICE.push({
            id: index,
            label: item.DESCRIPTION,
            value: item.OFFICE
          });
        });
      }
      else {

      }
    });
  },
  methods: {
    EnterNext() {
      if(this.ChangeBranch === '' || this.ChangeBranch === null) {
        Swal.fire({
          icon: 'error',
          html: '<lable class="fs-4 fw-normal font-family">กรุณาระบุสาขาที่ต้องการย้าย</lable>',
        });
      }
      else if(this.MemoChangBranch === '' || this.MemoChangBranch === null) {
        Swal.fire({
          icon: 'error',
          html: '<lable class="fs-4 fw-normal font-family">กรุณาระบุวัตถุประสงค์ของการขอย้าย</lable>',
        });
      }
      else {
        let DATA_BEFORE = { 
          AGENT_NAME: '',
          BARNCH: this.Branch
        };
        this.$store.state.PASS_OFFICE.DETAIL.push(DATA_BEFORE);
        this.ZTB_OFFICE.forEach(item => {
          if(item.value === this.ChangeBranch) {
            this.$store.state.PASS_OFFICE.OFFICE = item.label;
          }
        });
        this.$store.state.PASS_OFFICE.MEMO = this.MemoChangBranch;

        //SET DATA INSERT DATABASE
        this.$store.state.CHANGE_OFFICE.AGENTCODE = this.$store.state.AgentCode;
        
        this.$store.state.CHANGE_OFFICE.AGENTCODE_CHG.push(this.$store.state.AgentCode);
        this.$store.state.CHANGE_OFFICE.OFFICE = this.ChangeBranch;
        this.$store.state.CHANGE_OFFICE.SUBJOB = 'B01';
        this.$store.state.CHANGE_OFFICE.CHG_BY = 'AGT';
        this.$store.state.CHANGE_OFFICE.REASON_DTL = this.MemoChangBranch;

        this.$router.push('/FinishAgentBranch');
      }
    },
  },
};
</script>

<style scoped>

</style>